import { useState } from 'react';

import { BarChart } from '@mui/x-charts/BarChart';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { axisClasses } from '@mui/x-charts';
import { useTranslation } from 'react-i18next';

import styles from '../../../../pages/Profile/ProfileInsights/ProfileInsights.module.css';
import BasicPopup from '../../Popups/BasicPopup/BasicPopup';
import CustomDateForm from '../../../Forms/Common/CustomDateForm/CustomDateForm';
import { dataset } from '../../../../pages/Profile/dataset/weather';

export const ProfileViewsUI = () => {
    const { t, i18n } = useTranslation();
    const [activeView, setActiveView] = useState('yearly');
    const [isOpenCustomDatePopup, setisOpenCustomDatePopup] = useState(false);

    const handleViewChange = (view) => {
        setActiveView(view);
        if (view == 'custom') { handlePopupOpen() }
    };

    const formik = useFormik({
        initialValues: {
            custom: []
        },
        onSubmit: values => { }
    });
    
    const handleAddEducation = (values) => {
        formik.setFieldValue('custom', [{ id: Date.now(), ...values }]);
        handlePopupClose();
    }
    
    const profileInsights = useSelector(state => state.user.user.profileInsights);
    const datasets = formik.values.custom.length > 0 ? dataset(i18n.language, profileInsights, formik.values.custom[0].startDate, formik.values.custom[0].endDate) : dataset(i18n.language, profileInsights,);
    const currentDataset = datasets[activeView];
    const isSingleDataPoint = currentDataset?.filter((e) => e.value < 10) || [];

    const chartSetting = {
        yAxis: [
            isSingleDataPoint.length > 0 ? {
                disableLine: true,
                disableTicks: true,
                label: '',
                max: 10,
            } : {
                disableLine: true,
                disableTicks: true,
                label: '',
            }

        ],
        series: [
            {
                dataKey: 'value',
                valueFormatter: (value) => `${value} views`, // Formats the bar values
            },
        ],
        height: 350,
        width: 1100,
        sx: {
            [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
                transform: 'translateX(-10px)',
            },
        },
    };

    const handlePopupClose = () => {
        setisOpenCustomDatePopup(false);
    }

    const handlePopupOpen = (popupName) => {
        setisOpenCustomDatePopup(true);
    }
    return (
        <div className={styles.sectionWrapper}>
            {isOpenCustomDatePopup &&
                <BasicPopup
                    isOpen={isOpenCustomDatePopup}
                    closePopup={() => handlePopupClose()}
                >
                    <CustomDateForm onSubmit={handleAddEducation} />
                </BasicPopup>
            }
            <div className={styles.header}>
                <p className={styles.heading}>{t('profileViews.heading')}</p> {/* Translated heading */}
                <div className={styles.buttonGroup}>
                    {["custom", 'Daily', 'Weekly', 'Monthly', 'Yearly'].map((label, index) => (
                        <>
                            <button
                                key={label}
                                className={
                                    activeView === label.toLowerCase()
                                        ? `${styles.button} ${styles.active}`
                                        : styles.button
                                }
                                onClick={() => handleViewChange(label.toLowerCase())}
                            >
                                {t(`profileViews.buttons.${label.toLowerCase()}`)}

                            </button>
                            {index < 3 && <div className={styles.saperator}></div>}
                        </>
                    ))}
                </div>
            </div>
            <div className={styles.chartContainer}>
                <div className={styles.forMobileScroll}></div>
                {datasets[activeView] ?
                    <BarChart
                        dataset={datasets[activeView] || []}
                        yAxis={[{
                            disableLine: true,
                        }]}
                        xAxis={[{
                            scaleType: 'band', dataKey: activeView === 'custom' ? 'day' : activeView === 'daily' ? 'day' : activeView === 'weekly' ? 'week' : activeView === 'monthly' ? 'month' : 'year',
                            categoryGapRatio: .9,
                            tickPlacement: "middle",
                            tickLabelPlacement: "middle",
                            disableLine: true,
                            disableTicks: true,
                            colorMap: {
                                type: 'piecewise',
                                thresholds: [new Date(2021, 1, 1), new Date(2023, 1, 1)],
                                colors: ["#09AEEF"],
                            }
                        }]}
                        borderRadius={5}
                        grid={{ horizontal: true }}
                        {...chartSetting}
                    />
                    :
                    <div className={styles.barChartNoData}>{t('employerStats.noData')}</div>


                }
            </div>
        </div>
    );
};
